import { getEndpoint } from "@api-routes/endpoint";

const ACCOUNT_RECEIVABLE_FACADE_MS_NAME = "account-receivable-facade";
const MS_ENDPOINT_URL = getEndpoint(ACCOUNT_RECEIVABLE_FACADE_MS_NAME);

export const getAccountBalanceApiRoute = (accountId: string) => `${MS_ENDPOINT_URL}balance?accountIds=${accountId}`;

export const getTransactionHistoryListApiRoute = (accountId: string, query: string) =>
    `${MS_ENDPOINT_URL}balance/${accountId}/summary/paginated${query}`;
